const overview = {
	add: "VPS aanmaken",
	empty_list: {
		title: "U heeft nog geen VPS'en",
	},
	notifications: {
		create:
			"Uw VPS <strong>{{name}}</strong> wordt aangemaakt, het kan even duren voordat deze zichtbaar is.",
		delete:
			"Uw VPS <strong>{{name}}</strong> is succesvol verwijderd, het kan even duren voordat dit zichtbaar is.",
		network_already_existing:
			"Private network <strong>{{name}}</strong> kan niet aangemaakt worden. Deze naam is al in gebruik.",
		no_network:
			"Uw VPS heeft geen openbare of privénetwerken geconfigureerd. Voeg minstens één van beiden toe.",
	},
	search_input: "VPS zoeken",
	service_unavailable: {
		button: "Pagina herladen",
		description: "Probeert u het later opnieuw.",
		title: "De service is op dit moment niet bereikbaar.",
	},
	title: "VPS overzicht",
};

export default overview;
